function Filters({ filters, setFilters, sortOption, setSortOption }) {
  const toggle = (key, val) => {
    setFilters(f => {
      const arr = f[key];
      return { ...f, [key]: arr.includes(val) ? arr.filter(x => x !== val) : [...arr, val] };
    });
  };

  const hasActive = filters.statuses.length || filters.salaries.length
    || filters.dateRange !== 'all' || filters.search || filters.favoritesOnly;

  return (
    <div className="filters sketch-box">
      <div className="filter-row filter-row-top">
        <div className="filter-search-wrap">
          <div className="filter-search-field">
            <svg className="filter-search-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="8.5" cy="8.5" r="5" stroke="currentColor" strokeWidth="1.5"/>
              <path d="M13 13l3.5 3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
            <input
              className="sketch-input filter-search"
              placeholder="search company, title…"
              value={filters.search}
              onChange={(e) => setFilters(f => ({ ...f, search: e.target.value }))}
            />
            {filters.search && (
              <button
                type="button"
                className="filter-search-clear"
                onClick={() => setFilters(f => ({ ...f, search: '' }))}
                aria-label="Clear search"
              >
                ×
              </button>
            )}
          </div>
        </div>

        <div className="filter-pills favorite-filters">
          <button
            className={`filter-pill ${filters.favoritesOnly ? 'on' : ''}`}
            onClick={() => setFilters(f => ({ ...f, favoritesOnly: !f.favoritesOnly }))}
          >
            <span className="material-icons favorite-heart" style={{ fontSize: 14, verticalAlign: 'middle', marginRight: 4 }}>auto_awesome</span>favorites
          </button>
        </div>

        <div className="filter-pills status-filters">
          <span className="label">status:</span>
          {STATUSES.map(s => (
            <button
              key={s.id}
              className={`filter-pill ${filters.statuses.includes(s.id) ? 'on' : ''}`}
              onClick={() => toggle('statuses', s.id)}
            >
              {s.label}
            </button>
          ))}
        </div>

      </div>

      <div className="filter-row filter-row-bottom">
        <div className="filter-pills date-filters">
          <span className="label">when:</span>
          {['all', 'today', '7', '30'].map(d => (
            <button
              key={d}
              className={`filter-pill ${filters.dateRange === d ? 'on' : ''}`}
              onClick={() => setFilters(f => ({ ...f, dateRange: d }))}
            >
              {d === 'all' ? 'all' : d === 'today' ? 'today' : `last ${d}d`}
            </button>
          ))}
        </div>

        <div className="filter-pills salary-filters">
          <span className="label">salary</span>

          {SALARY_BANDS.map(b => (
            <button
              key={b}
              className={`filter-pill ${filters.salaries.includes(b) ? 'on' : ''}`}
              onClick={() => toggle('salaries', b)}
            >
              {b}
            </button>
          ))}
        </div>

        <div className="filter-pills sort-filters">
          <select
            className="sketch-input filter-sort-select"
            value={sortOption}
            onChange={(event) => setSortOption(event.target.value)}
          >
            {SORT_OPTIONS.map(option => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
          </select>
        </div>
      </div>

      {hasActive && (
        <button
          type="button"
          className="filter-pill clear-filters"
          onClick={() => setFilters({ statuses: [], salaries: [], dateRange: 'all', search: '', favoritesOnly: false })}
        >
          clear ✕
        </button>
      )}
    </div>
  );
}
